import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Expandable, Spinner } from 'UI';
import { translate } from '@haldor/ui';
var SelectedCoreContent = /*#__PURE__*/function (_Component) {
  function SelectedCoreContent() {
    _classCallCheck(this, SelectedCoreContent);
    return _callSuper(this, SelectedCoreContent, arguments);
  }
  _inherits(SelectedCoreContent, _Component);
  return _createClass(SelectedCoreContent, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        translate = _this$props.translate,
        coreContent = _this$props.coreContent;
      if (coreContent == null || this.props.activeSection == null) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      var forbiddenText = "Undervisningen i kursen ska behandla följande centrala innehåll:";
      return /*#__PURE__*/React.createElement("div", {
        className: "core-content selected"
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: translate('This plan contains the following subject/lesson content:'),
        whiteBackground: true,
        key: 'core-content-container'
      }, coreContent.map(function (content, index) {
        var title = "";
        if (_this.props.activeSection != null) {
          _this.props.activeSection.courses.forEach(function (course) {
            course.details.forEach(function (detail) {
              if (detail.id == content.coreContents[0].courseDetailsId) {
                title = "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(course.courseCode, ")");
              }
            });
          });
        }
        return /*#__PURE__*/React.createElement("div", {
          key: 'coreContent' + index
        }, /*#__PURE__*/React.createElement("h2", null, title), content.coreContents.map(function (contentRow) {
          var contentRowTitle = contentRow.title.trim();
          return /*#__PURE__*/React.createElement("div", {
            className: "core-content-row",
            key: 'core-content-' + contentRow.id
          }, contentRowTitle !== "" && contentRowTitle !== forbiddenText ? /*#__PURE__*/React.createElement("h3", null, contentRowTitle) : null, contentRow.aspects.map(function (aspect) {
            return /*#__PURE__*/React.createElement("div", {
              className: "content-row",
              key: 'core-content-row-' + aspect.id
            }, /*#__PURE__*/React.createElement("h4", null, aspect.title != forbiddenText ? aspect.title : ''), /*#__PURE__*/React.createElement("ul", null, aspect.aspectRows.map(function (row) {
              return /*#__PURE__*/React.createElement("li", {
                key: 'aspect-row-' + row.id
              }, row.text);
            })));
          }));
        }));
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeSection: state.groups.activeGroup,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(SelectedCoreContent);